import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SidebarComponent } from './sidebar.component';
import { AvatarModule } from 'primeng/avatar';
import { TooltipModule } from 'primeng/tooltip';
import { SelectModule } from 'primeng/select';
import { FormsModule } from '@angular/forms';
import { SidebarIconComponent } from '../../../shared/ui/sidebar-icon/sidebar-icon.component';

@NgModule({
  declarations: [SidebarComponent],
  imports: [CommonModule, RouterModule, AvatarModule, TooltipModule, SelectModule, FormsModule, SidebarIconComponent],
  exports: [SidebarComponent],
})
export class SidebarModule {}
